module.exports = "/img/CaseStudy.019bef.png";